module.exports = __webpack_public_path__ + "static/media/visa.6271fc47.svg";